/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Sales_Return_Err_Fee_MaxInputs */

const vi_sales_return_err_fee_max = /** @type {(inputs: Sales_Return_Err_Fee_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Phí không được lớn hơn số tiền khách đã trả dư (${i?.max})`)
};

/**

* @param {Sales_Return_Err_Fee_MaxInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_err_fee_max = /** @type {((inputs: Sales_Return_Err_Fee_MaxInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Err_Fee_MaxInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_err_fee_max(inputs)
});